import ApiService from "@/services/api.service";
import EmonsVue, {log} from "@emons/emons-vue"

const rel = 'notifications'
const path = '/api/admin/notifications';
const schema = {
    title: null,
    text: null,
    audience: 'ALL',
    validFrom: null,
    validUntil: null
}

const translate = function (key) {
    return EmonsVue.vm?.$t ? EmonsVue.vm.$t(key) : key
}

const formatDateTime = function (dateTime, defaultTime, emptyKey) {
    if (!dateTime)
        return translate(emptyKey)

    const date = dateTime.substring(0, 10).split('-').reverse().join('.')
    const time = dateTime.substring(11, 16)
    return time && time !== defaultTime ? date + ' ' + time : date
}

const header = {
    title: {
        name: 'notification.title',
        col: 'col-3',
        property: 'title'
    },
    text: {
        name: 'notification.text',
        col: 'col-3',
        property: 'text'
    },
    audience: {
        name: 'notification.audience',
        col: 'col-2',
        property: 'audience',
        formatter: function (val) {
            return val ? translate('notification.audience.' + val) : ''
        }
    },
    validFrom: {
        name: 'notification.validFrom',
        col: 'col-2',
        property: 'validFrom',
        formatter: function (val) {
            return formatDateTime(val, '00:00', 'notification.validFrom.empty')
        }
    },
    validUntil: {
        name: 'notification.validUntil',
        col: 'col-2',
        property: 'validUntil',
        formatter: function (val) {
            return formatDateTime(val, '23:59', 'notification.validUntil.empty')
        }
    }
}
const filter = null
const sync = null
const initialSort = 'created'
const initialSortDirection = 'desc'
const projection = 'list'
const create = true;

const parseList = function (data) {
    if (data) {
        let parsedData = JSON.parse(data)

        if (parsedData) {
            let response = {
                links: parsedData['_links'],
                page: parsedData['page'],
                items: parsedData['_embedded'] && parsedData['_embedded'][rel] ? parsedData['_embedded'][rel] : []
            }

            response.items.forEach(item => {
                ApiService.ensureSchema(schema, item)
            })

            return response
        }
    }
}

const Service = {
    getHeader: function () {
        return header
    },
    getFilter: function () {
        return filter
    },
    getSync: function () {
        return sync
    },
    getCreate: function () {
        return create
    },
    getInitialSort: function () {
        return initialSort
    },
    getInitialSortDirection: function () {
        return initialSortDirection
    },
    getProjection: function () {
        return projection
    },
    find: async function (query,
                          filters,
                          projection,
                          sortProperty,
                          sortDirection,
                          size) {
        try {
            return ApiService.get(path, {
                params: {
                    query: query || undefined,
                    sort: sortProperty + ',' + sortDirection,
                    size: size != null ? size : 100
                },
                transformResponse: [function (data) {
                    const response = parseList(data)
                    log("debug", "find():", response)
                    return response
                }]
            })
        } catch (error) {
            log('error', 'Error querying ' + rel + ':', error)
        }
    },
    nextPage: async function (link) {
        try {
            return ApiService.get(link, {
                params: {},
                transformResponse: [function (data) {
                    const response = parseList(data)
                    log("debug", "nextPage():", response)
                    return response
                }]
            })
        } catch (error) {
            log("error", "Error on next page:", error)
        }
    },
    getEntityDetails: async function (link) {
        try {
            return ApiService.get(this.cleanLink(link))
        } catch (error) {
            log("error", "Error querying entity:", error)
        }
    },
    save: async function (entity) {
        const payload = {
            title: entity.title || null,
            text: entity.text,
            audience: entity.audience,
            validFrom: entity.validFrom || null,
            validUntil: entity.validUntil || null
        }
        const request = entity._links && entity._links.self
            ? ApiService.put(this.cleanLink(entity._links.self.href), payload)
            : ApiService.post(path, payload)

        return request.then(response => {
            if (response.data)
                ApiService.ensureSchema(schema, response.data)

            return response
        })
    },
    delete: async function (entity) {
        if (entity._links && entity._links.self) {
            return ApiService.delete(this.cleanLink(entity._links.self.href))
        }
    },
    resetRead: async function (entity) {
        if (entity._links && entity._links.resetRead) {
            return ApiService.post(this.cleanLink(entity._links.resetRead.href))
        }
    },
    create: function () {
        log('debug', 'create() called...')
        return ApiService.ensureSchema(schema, {
            isOpen: true,
            changed: true
        });
    },
    cleanLink: function (link) {
        if (link) {
            if (link.indexOf('{') > -1)
                link = link.split('{')[0];

            if (link.indexOf('?') > -1)
                link = link.split('?')[0];

            return link;
        } else
            return link;
    }
}

export default Service
